<img [attr.aut-id]="'avatar-img'" [src]="destinationSrc" [alt]="altDescription" />
